import { ID_GRAPH_AXIS } from '../../constants/idDefinition';
import { CHART_TYPE, SIMULATION_TYPE, UNITS_SIGN } from '../../constants/definitionConstants';
import { getDomain } from '../../../utils/config';

export class railldo {
	constructor(opn) {
		this.opn = opn;
		this.domain = getDomain();
		this.wpn = 'ncv8730';
		this.SCHEMATIC = require(`../../images/${this.opn}_SCH.svg`);
		this.netlistPath = 'resources/railldo/railldo/netlists/railldo_Trans.txt';
	}

	gainDefinition() {
		const TRANSIENT_CHART_COLUMN_MAPPING = {
			TIME: 0,
			TEMP: 1,
			R_Delay: 2,
			V_IN: 3,
			V_EN: 4,
			V_OUT1: 5,
			V_IN23: 6,
			V_OUT2: 7,
			V_OUT3: 8,
			I_OUT1: 9,
			I_OUT2: 10,
			I_OUT3: 11,
			I_GND1: 12,
			I_GND2: 13,
			I_GND3: 14,
			P_LDO1: 15,
			P_LDO2: 16,
			P_LDO3: 17
		};
		return {
			/**
			 * Name of Page
			 */
			mainHeading: 'LDO Rail Demo',
			wpn: this.wpn.toUpperCase(),

			/**
			 * is used to get description, table, primary and secondary links base parameter to pull data from WD+ database (value is OPN)
			 */
			defaultMappingName: this.opn,
			simulations: [
				{
					heading: 'Start up sequence under load conditions',
					showRawData: false,
					inputHeading: 'Input parameters',
					note: 'Results are linearly decimated based on t<sub>step<sub>max</sub></sub> parameter.',
					showInputParams: false,
					inputParameters: [
						{
							heading: 'V<sub>IN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmin',
							minBoundary: 0,
							maxBoundary: 37,
							defaultValue: 0
						},
						{
							heading: 'V<sub>IN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmax',
							minBoundary: 7,
							maxBoundary: 38,
							defaultValue: 9
						},
						{
							heading: 't<sub>rise<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtr',
							minBoundary: 1,
							maxBoundary: 100,
							defaultValue: 20
						},
						{
							heading: 't<sub>ON<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtON',
							minBoundary: 1,
							maxBoundary: 300,
							defaultValue: 80
						},
						{
							heading: 't<sub>EN<sub>delay</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtDelay',
							minBoundary: 0,
							maxBoundary: 100,
							defaultValue: 20
						},
						{
							heading: 't<sub>EN<sub>rise</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtr',
							minBoundary: 0.1,
							maxBoundary: 100,
							defaultValue: 5
						},
						{
							heading: 't<sub>step<sub>max</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'Tstep',
							minBoundary: 0.5,
							maxBoundary: 10,
							defaultValue: 2.5
						},
						{
							heading: 'R<sub>Delay<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'R_delayMin',
							minBoundary: 1000,
							maxBoundary: 1500,
							defaultValue: 1100
						},
						{
							heading: 'R<sub>Delay<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'R_delayMax',
							minBoundary: 1500,
							maxBoundary: 2500,
							defaultValue: 1500
						},
						{
							heading: 'R<sub>Delay<sub>(num.steps)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nRdSteps',
							minBoundary: 1,
							maxBoundary: 3,
							defaultValue: 1,
							isInteger: true
						},
						{
							heading: 'R<sub>TOP</sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'Rup',
							minBoundary: 250,
							maxBoundary: 2000,
							defaultValue: 650
						},
						{
							heading: 'R<sub>BOT</sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'Rdown',
							minBoundary: 100,
							maxBoundary: 2000,
							defaultValue: 110
						},
						{
							heading: 'R<sub>OUT1</sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'Load1',
							minBoundary: 100,
							maxBoundary: 2000,
							defaultValue: 300
						},
						{
							heading: 'R<sub>OUT2</sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'Load2',
							minBoundary: 180,
							maxBoundary: 2000,
							defaultValue: 180
						},
						{
							heading: 'R<sub>OUT3</sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'Load3',
							minBoundary: 150,
							maxBoundary: 2000,
							defaultValue: 150
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40,
							maxBoundary: 125,
							defaultValue: 25,
							displayInput: true
						}
					],
					netlist: {
						heading: 'Netlist',
						netlistPath: this.netlistPath,
						displayNetlist: true
					},
					schematic: {
						heading: 'Application schematic',
						schematicPath: this.SCHEMATIC
					},
					charts: [
						{
							id: 'ComposedChart',
							mainHeading: 'Timing Diagram',
							chartType: CHART_TYPE.COMPOSITE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'Voltage',
									unit: UNITS_SIGN.VOLT
									/*columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
									 */
								}
							],
							composedCharts: [
								{
									id: 'VinVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]IN[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'VenVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]EN[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'Vout1VsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]OUT1[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'Vout2VsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]OUT2[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'Vout3VsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]OUT3[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'VIN23VsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]IN23[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								}
							],
							series: {
								heading: 'Voltages:',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'IloadVsTime',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]OUT[/] = f (t)',
							chartType: CHART_TYPE.COMPOSITE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.AMPER
									/*columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
									 */
								}
							],
							composedCharts: [
								{
									id: 'Iout1VsTime',
									seriesLabel:
										'I[baseline-shift: sub; font-size: 11px;]OUT1[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'Iout2VsTime',
									seriesLabel:
										'I[baseline-shift: sub; font-size: 11px;]OUT2[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'Iout3VsTime',
									seriesLabel:
										'I[baseline-shift: sub; font-size: 11px;]OUT3[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								}
							],
							series: {
								heading: 'Load currents:',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'IgndVsTime',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]GND[/] = f (t)',
							chartType: CHART_TYPE.COMPOSITE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GND[/]',
									unit: UNITS_SIGN.AMPER
									/*columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
									 */
								}
							],
							composedCharts: [
								{
									id: 'Ignd1VsTime',
									seriesLabel:
										'I[baseline-shift: sub; font-size: 11px;]GND1[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'Ignd2VsTime',
									seriesLabel:
										'I[baseline-shift: sub; font-size: 11px;]GND2[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'Ignd3VsTime',
									seriesLabel:
										'I[baseline-shift: sub; font-size: 11px;]GND3[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								}
							],
							series: {
								heading: 'Ground currents:',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'PdVsTime',
							mainHeading: 'P[baseline-shift: sub; font-size: 11px;]LDO[/] = f (t)',
							chartType: CHART_TYPE.COMPOSITE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'P[baseline-shift: sub; font-size: 11px;]LDO[/]',
									unit: UNITS_SIGN.WATT
									/*columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
									 */
								}
							],
							composedCharts: [
								{
									id: 'Pd1VsTime',
									seriesLabel:
										'P[baseline-shift: sub; font-size: 11px;]LDO1[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'Pd2VsTime',
									seriesLabel:
										'P[baseline-shift: sub; font-size: 11px;]LDO2[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								},
								{
									id: 'Pd3VsTime',
									seriesLabel:
										'P[baseline-shift: sub; font-size: 11px;]LDO3[/] @ R[baseline-shift: sub; font-size: 11px;]Delay[/] = '
								}
							],
							series: {
								heading: 'Power dissipation',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'VinVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]IN[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'VenVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]EN[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]EN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_EN
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Vout1VsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]OUT1[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]OUT1[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_OUT1
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Vout2VsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]OUT2[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]OUT2[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_OUT2
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Vout3VsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]OUT3[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]OUT3[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_OUT3
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'VIN23VsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]IN23[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN23[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN23
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Iout1VsTime',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]OUT1[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]OUT1[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_OUT1
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Iout2VsTime',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]OUT2[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]OUT2[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_OUT2
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Iout3VsTime',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]OUT3[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]OUT3[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_OUT3
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Ignd1VsTime',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]GND1[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GND1[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_GND1
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Ignd2VsTime',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]GND2[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GND2[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_GND2
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Ignd3VsTime',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]GND3[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GND3[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_GND3
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Pd1VsTime',
							mainHeading: 'P[baseline-shift: sub; font-size: 11px;]LDO1[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'P[baseline-shift: sub; font-size: 11px;]LDO1[/]',
									unit: UNITS_SIGN.WATT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.P_LDO1
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Pd2VsTime',
							mainHeading: 'P[baseline-shift: sub; font-size: 11px;]LDO2[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'P[baseline-shift: sub; font-size: 11px;]LDO2[/]',
									unit: UNITS_SIGN.WATT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.P_LDO2
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						},
						{
							id: 'Pd3VsTime',
							mainHeading: 'P[baseline-shift: sub; font-size: 11px;]LDO3[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'P[baseline-shift: sub; font-size: 11px;]LDO3[/]',
									unit: UNITS_SIGN.WATT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.P_LDO3
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]Delay[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_Delay
							}
						}
					]
				}
			]
		};
	}
}
